import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import SeamlessBackground from './SeamlessBackground';
import Navbar from './Navbar';

const MarketingLayout: React.FC = () => {
    const location = useLocation();

    return (
        <div className="min-h-screen bg-[#022334] text-white font-sans antialiased relative overflow-x-hidden">
            {/* Background — single mount, persists across route changes */}
            <SeamlessBackground />

            {/* Navbar — z-50, sits above the page-transition layer */}
            <div className="relative" style={{ zIndex: 50 }}>
                <Navbar />
            </div>

            {/* Page transition layer — Smart Animate-style 800ms ease-in-out crossfade */}
            <AnimatePresence mode="wait">
                <motion.main
                    key={location.pathname}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4, ease: 'easeInOut' }}
                    className="relative"
                    style={{ zIndex: 10 }}
                >
                    <Outlet />
                </motion.main>
            </AnimatePresence>
        </div>
    );
};

export default MarketingLayout;
